import { z } from 'zod';
import isFQDN from 'validator/lib/isFQDN';
import { GenerateTemplateStatusEnum } from './GenerateTemplateStatus';

export const SchoolStatusEnum = z.enum([
  'approved',
  'initiated',
  'pending',
  'rejected',
]);

export type SchoolStatus = z.infer<typeof SchoolStatusEnum>;

export const SchoolSchema = z.object({
  adminEmail: z.string(),
  city: z.string().optional(),
  classroomsIds: z.string().array(),
  domains: z.string().array(),
  driveRootFolderId: z.string().optional(),
  id: z.string(),
  name: z.string(),
  state: z.string().optional(),
  demoTeacherWhiteList: z.string().array().optional(),
  demoStudentWhiteList: z.record(z.string(), z.string()).optional(),
  templatesFolderId: z.string().optional(),
  folderIdByTeacherEmail: z.record(z.string(), z.string()).optional(),
  website: z.string(),
  status: SchoolStatusEnum,
  generateTemplatesStatus: GenerateTemplateStatusEnum.optional(),
  generateTeacherTemplatesStatus: GenerateTemplateStatusEnum.optional(),
  serviceAccountSecret: z.string().optional(),
  serviceAccountEmail: z.string().optional(),
});

export type School = z.infer<typeof SchoolSchema>;

export const SCHOOL_STATES = [
  'Alabama',
  'Alaska',
  'American Samoa',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'District Of Columbia',
  'Federated States Of Micronesia',
  'Florida',
  'Georgia',
  'Guam',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Marshall Islands',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Northern Mariana Islands',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Palau',
  'Pennsylvania',
  'Puerto Rico',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virgin Islands',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
];

export const schoolDomainValidation = z
  .string()
  .optional()
  .refine((v) => (v ? isFQDN(v) : true), { message: 'school_invalid_domain' })
  .array();

export const schoolFactory = (school: Partial<School>): School => {
  return {
    adminEmail: school.adminEmail ?? '',
    city: school.city ?? '',
    classroomsIds: school.classroomsIds ?? [],
    driveRootFolderId: school.driveRootFolderId ?? '',
    id: school.id ?? '',
    name: school.name ?? '',
    state: school.state ?? '',
    website: school.website ?? '',
    status: school?.status ?? SchoolStatusEnum.enum.pending,
    domains: school?.domains ?? [],
  };
};
